import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content"]

  connect() {
    this.dialogTarget.addEventListener("click", (e) => {
      if (e.target === this.dialogTarget) this.close(e)
    })
  }

  async open(event) {
    event.preventDefault()
    const response = await fetch("/events/wizard?modal=1", {
      headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" }
    })
    if (!response.ok) return
    this.contentTarget.innerHTML = await response.text()
    this.dialogTarget.showModal()
  }

  close(event) {
    if (event) event.preventDefault()
    this.dialogTarget.close()
    this.contentTarget.innerHTML = ""
  }
}
